/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "../../axios.js"
import jwt from "../../http/requests/auth/jwt/index.js"

export default {
  AUTH_REQUEST(state) {
    state.status = 'loading'
  },
  AUTH_SUCCESS(state, token) {
    state.status = 'success'
    state.token = token
  },
  AUTH_ERROR(state) {
    state.status = 'error'
  },
  SET_BEARER(state, accessToken) {
    state.token = accessToken;      
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken
       // Update user details
       
  },
  CLEAR_BEARER() {
    axios.defaults.headers.Authorization;
       
  }

}
